import { EVENT_STATUS } from '@monorepo/config';
import { toNumber } from '../../core/utils/helperFunc';

// Đổi response REST về đúng shape mà GraphQL getByCodeAndPhone từng trả, để 3 màn đang dùng
// (TrackingDetail, RequestInformationComplain, OrderEvents) không phải sửa gì.

// REST đặt tên deliver3partyConfig (chữ p thường), GraphQL là deliver3PartyConfig.
// Chỉ map 2 khối getShippingRows thật sự đọc.
const mapShippingConfig = (shippingConfig) => {
  if (!shippingConfig) return null;
  return {
    busConfig: shippingConfig.busConfig,
    deliver3PartyConfig: shippingConfig.deliver3partyConfig,
  };
};

// proto3 in tên đầy đủ của enum. Giá trị lạ giữ nguyên chuỗi của BE, không đổi thành rỗng.
const BE_EVENT_STATE_TO_UI = {
  FULL_ORDER_EVENT_STATE_PAST: EVENT_STATUS.PAST,
  FULL_ORDER_EVENT_STATE_CURRENT: EVENT_STATUS.CURRENT,
  FULL_ORDER_EVENT_STATE_FUTURE: EVENT_STATUS.FUTURE,
};

const mapFullEvent = (event) => ({
  state: BE_EVENT_STATE_TO_UI[event?.state] ?? event?.state,
  name: event?.name,
  createdAt: event?.createdAt,
});

// REST trả phẳng {attributeName, value}. REST không có ID thuộc tính; attributeID chỉ được
// renderVariantAttributes dùng làm React key nên lấy vị trí trong mảng.
const mapVariantAttribute = (variant, index) => ({
  attributeID: index,
  attribute: { name: variant?.attributeName },
  attributeValue: { value: variant?.value },
});

// REST trả ảnh/đơn vị tính phẳng ngay trên item, GraphQL lồng trong product.
// Luồng khiếu nại dùng lại hàm này: BE trả cùng một message cho sản phẩm của đơn và của khiếu nại.
export const mapItem = (item) => ({
  productID: item?.productId,
  productName: item?.productName,
  productCode: item?.productCode,
  quantity: toNumber(item?.quantity),
  product: {
    imageURL: item?.imageUrl,
    uom: item?.uomName ? { name: item.uomName } : null,
    variantAttributeValues: (item?.variantAttributes || []).map(mapVariantAttribute),
  },
});

export const mapOrderTracking = (response) => {
  const info = response?.orderTrackingInfo;
  if (!info) return null;

  return {
    number: info.number,
    status: info.status,
    orderType: info.orderType,
    paymentMethod: info.paymentMethod,
    paymentMethodName: info.paymentMethodName,
    shippingType: info.shippingType,
    shippingTypeName: info.shippingTypeName,
    senderName: info.senderName,
    senderPhone: info.senderPhone,
    senderAddress: info.senderAddress,
    receiverContactName: info.receiverContactName,
    receiverContactPhone: info.receiverContactPhone,
    receiverContactAddress: info.receiverContactAddress,
    total: toNumber(info.total),
    shippingConfiguration: mapShippingConfig(info.shippingConfig),
    fullEvents: (info.fullEvents || []).map(mapFullEvent),
    items: (info.items || []).map(mapItem),
  };
};
